import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from '../../../theme';
import { renderHeader } from '../renderers/renderHeader';
import { headerCellHeight } from '../constants';
const Container = styled.div.withConfig({ displayName: "vui--Container", componentId: "vui--xy0vyq" }) `display:grid;grid-template-columns:auto 1fr;align-items:center;position:absolute;top:0;left:0;right:0;z-index:50;height:${headerCellHeight};background-color:white;`;
const Content = styled.div.withConfig({ displayName: "vui--Content", componentId: "vui--vgmrdc" }) `width:100%;height:100%;display:flex;align-items:center;padding:0 0.5rem;border-bottom:1px solid ${theme.colors.neutral.grey.base};& > *{flex:1;}`;
export function ActionBar({ selectionColumn, intersectionTargetRef, containerRef, children, }) {
    var _a;
    const [isSticky, setIsSticky] = useState(false);
    useEffect(() => {
        if (!intersectionTargetRef.current)
            return;
        const callback = (entries) => {
            entries.forEach((entry) => {
                setIsSticky(!entry.isIntersecting);
            });
        };
        const intersectionObserver = new IntersectionObserver(callback);
        intersectionObserver.observe(intersectionTargetRef.current);
        /* eslint-disable-next-line consistent-return */
        return () => intersectionObserver.disconnect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [intersectionTargetRef.current]);
    const containerRect = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    const defaultPositionStyles = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
    };
    const stickyPositionStyles = {
        position: 'fixed',
        top: 0,
        left: containerRect === null || containerRect === void 0 ? void 0 : containerRect.left,
        width: containerRect === null || containerRect === void 0 ? void 0 : containerRect.width,
    };
    const style = isSticky ? stickyPositionStyles : defaultPositionStyles;
    return (React.createElement(Container, { style: style },
        renderHeader({ column: selectionColumn }),
        React.createElement(Content, null, children)));
}
//# sourceMappingURL=ActionBar.js.map